import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        container:{
            maxHeight:'520px',
            '& .MuiPaper-root':{
                maxHeight:'404px'
            }
        },
        containerFilter: {
            position: 'relative',
            width:'40px',
            height: '40px',
            '& .MuiBadge-root':{
                borderRadius: '6px'
            }
        },
        containerTitle:{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 2,
        },
        containerButtons:{
            display: 'flex',
            gap: 2,
        }
    }
}

export { useStyles }
